module.exports = __webpack_public_path__ + "img/bell-primary.57998ce6.svg";